
import ContactForm from './ContactForm';
import DeviceSection from './Device';
import FeatureSection from './Feature';
import HighlightSection from './Highlight';
import IntroduceSection from './Introduce';
import SolutionsSection from './Solution';
import Testimonials from './Testimonials';
const Main = () => {
    return (
        <>
            <IntroduceSection />
            <SolutionsSection />
            <FeatureSection />
            <HighlightSection />
            <DeviceSection />
            {/* <Testimonials /> */}
            <ContactForm />
        </>
    )
}

export default Main;